// Products.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { useProductsContext } from "../context/ProductsProvider";
import { doc, updateDoc, arrayUnion, arrayRemove, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase.config";
import styles from "./Products.module.css";
import style from "./SingleProduct.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faExpand, faEye } from "@fortawesome/free-solid-svg-icons";
import { Card, Button, Form, Row, Col, Container } from "react-bootstrap";

function Products({ id, title, color, size, path }) {
  const { state } = useProductsContext();
  const { currentUser } = useAuthContext();
  const { items } = state;

  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [quantity, setQuantity] = useState(0); // State to hold the quantity
  const [status, setStatus] = useState(""); // State to hold the status

  useEffect(() => {
    const currentItem = items.find(item => item.id === id);
    if (currentItem) {
      const likes = currentItem.likes || [];
      setLikesCount(likes.length);
      // Check if currentUser exists before setting liked state
      setLiked(currentUser && Array.isArray(likes) && likes.includes(currentUser.uid));
    } else {
      // Handle the case when currentItem is not found
      setLikesCount(0);
      setLiked(false);
    }
  }, [items, currentUser, id]);
  
  
  useEffect(() => {
    const updateStatus = (quantity) => {
      return quantity < 1 ? "Sold Out" : "";
    };
  
    // Fetch quantity from Firebase Firestore
    const fetchQuantity = async () => {
      try {
        const docRef = doc(db, "products", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const productData = docSnap.data();
          if (productData && productData.quantity !== undefined) {
            setQuantity(productData.quantity);
            setStatus(updateStatus(productData.quantity));
          }
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching quantity:", error);
      }
    };
  
    fetchQuantity();
  }, [id]);
  
  const handleLike = async () => {
    if (!currentUser) {
      alert("Please log in to like the product."); // Display error message
      return; // Exit the function if no user is logged in
    }
  
    const docRef = doc(db, 'products', id);
    if (liked) {
      // Unlike the product
      await updateDoc(docRef, { likes: arrayRemove(currentUser.uid) });
      setLiked(false);
      setLikesCount(prevCount => Math.max(prevCount - 1, 0)); // Decrement likes count, ensuring it's not negative
    } else {
      // Like the product
      await updateDoc(docRef, { likes: arrayUnion(currentUser.uid) });
      setLiked(true);
      setLikesCount(prevCount => prevCount + 1); // Increment likes count
    }
  };
  
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate(`/product/${id}`, { state: { id } });
  };

  return (
    <Container className={`${styles.main_text} g-1`}>
      <Card  className={`${styles.item_container} mb-1`} >
        <div>
          <div className={styles.img_container} >
            <p className={styles.status}>
              {status}
            </p>
            <img
              className={styles.img}
              src={path}
              alt="Product" 
            />
          </div>
          <div
            className={`${liked ? styles.liked : styles.unliked}`}
              onClick={handleLike}
            >
            <FontAwesomeIcon icon={faHeart} className={styles.like_icon} />
            <span style={{ fontSize: '18px', padding: "3px", color: "tomato" }}>{likesCount}</span>
          </div>
          <div>
            <FontAwesomeIcon className={styles.action} onClick={handleOnClick}  icon={faExpand} />
          </div>
          <Card.Title className={styles.title}>
          {title}
          </Card.Title>
        </div>
      </Card>
    </Container>
  );
}

export function SingleProduct({ title, description, size, quantity, color, path }) {

  return (
    <div className={style.Single_body_container}>
      <div className={style.Single_container} >
        <div className={style.Single_item_container} >
          <img 
            src={path}
            alt="item" >
          </img>
        </div>

        <div className={style.Single_item_container}>
          <div className={style.Single_item_info}>
            <div className={style.item} >
              <h3 className={style.title}> {title} </h3>
            </div>
            <hr />
            <div className={style.item}>
              <p className={style.info}>
                <strong >Color:</strong> {color}
              </p>
              <p className={style.info}>
              <strong >Qty:</strong> {quantity}
              </p>
              <p className={style.info}>
              <strong >Size:</strong> {size}
              </p>
            </div>

            <div className={style.item}>
              <p>
              <strong >Description:</strong> <br/> {description}
              </p>
            </div>

          </div>
          
        </div>
        
      </div>
    </div>
  )
}

export const Product = () => {
  const { id } = useParams();
  const { state } = useProductsContext();
  const { items } = state;

  // Check if id is valid and items is not empty
  if (!id || !items) {
    return <div>Product not found</div>;
  }

  const product = items.find(item => item.id === id);

  // Handle case where product is not found
  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div className={style.Single_body_container}>
      <div className={style.Single_container} >

        <div className={style.Single_item_container} >
          <img 
            src={product.path}
            alt="item" >
          </img>
        </div>

        <div className={style.Single_item_container}>

          <div className={style.Single_item_info}>

            <div className={style.item} >
              <h3 className={style.title}> {product.title} </h3>
            </div>

            <hr />

            <div className={style.item}>
              <p className={style.info}>
                <strong >Color:</strong> {product.color}
              </p>
              <p className={style.info}>
              <strong >Qty:</strong> {product.quantity}
              </p>
              <p className={style.info}>
              <strong >Size:</strong> {product.size}
              </p>
            </div>

            <div className={style.item}>
              <p>
              <strong >Description:</strong> <br/> {product.description}
              </p>
            </div>

          </div>
          
        </div>
        
      </div>
    </div>
  );
}


export default Products;
